import u from "../../../@babel/runtime/helpers/esm/slicedToArray2.mjs";
import * as i from "react";
import { findListDiffIndex as v } from "../utils/algorithmUtil.mjs";
function I(t, d, o) {
  var e = i.useState(t), r = u(e, 2), a = r[0], l = r[1], m = i.useState(null), f = u(m, 2), s = f[0], x = f[1];
  return i.useEffect(function() {
    var n = v(a || [], t || [], d);
    (n == null ? void 0 : n.index) !== void 0 && (o == null || o(n.index), x(t[n.index])), l(t);
  }, [t]), [s];
}
export {
  I as default
};
//# sourceMappingURL=useDiffItem.mjs.map
